// extracted by mini-css-extract-plugin
export default {"description":"NewProfessor_description__OPUsA","form":"NewProfessor_form__GDEq7","form__email":"NewProfessor_form__email__2SP-x","form__buttons":"NewProfessor_form__buttons__X4Hyq"};